var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.0236816,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#D5E4F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1258_5495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 12,
    height: 11
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.90002,
    y: 3.42358,
    width: 10.2,
    height: 10.2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1258_5495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55247 10.7762L7.59747 8.82117C7.55497 8.77867 7.52493 8.73263 7.50737 8.68305C7.48952 8.63346 7.48059 8.58034 7.48059 8.52367C7.48059 8.46701 7.48952 8.41388 7.50737 8.3643C7.52493 8.31471 7.55497 8.26867 7.59747 8.22617L9.55247 6.27117C9.63038 6.19326 9.72955 6.1543 9.84997 6.1543C9.97038 6.1543 10.0695 6.19326 10.1475 6.27117C10.2254 6.34909 10.2643 6.44826 10.2643 6.56867C10.2643 6.68909 10.2254 6.78826 10.1475 6.86617L8.48997 8.52367L10.1475 10.1812C10.2254 10.2591 10.2643 10.3583 10.2643 10.4787C10.2643 10.5991 10.2254 10.6983 10.1475 10.7762C10.0695 10.8541 9.97038 10.893 9.84997 10.893C9.72955 10.893 9.63038 10.8541 9.55247 10.7762Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButton);
export default __webpack_public_path__ + "static/media/icon-button.e866b7bb3b28cee16a942e69df1667df.svg";
export { ForwardRef as ReactComponent };